<!--  -->
<template>
  <div class="page" :class="{ active: tabIdx === 1 }">
    <div class="head-box">
      <div class="head">
        <div class="examYear" @click="show = !show">
          <span>{{ examSeasonName }}</span>
          <img
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examPlan/arrow.png"
            alt=""
          />
        </div>
        <div class="yearList" v-show="show">
          <div
            @click="changeYear(item.examSeasonId, item.examSeasonName)"
            :class="{ active: yearCode === item.examSeasonId }"
            v-for="(item, i) in examSeason"
            :key="i"
          >
            {{ item.examSeasonName }}
          </div>
        </div>
        <div class="tab">
          <div
            @click="changeTab(k)"
            :class="{ active: tabIdx !== k }"
            v-for="(item, k) in tab"
            :key="k"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="major" v-show="tabIdx === 1">
        <div
          class="subject"
          :id="`subject-${k}`"
          @click="changeSubject(item.disciplineId, k)"
          :class="{ active: subjectCode === item.disciplineId }"
          v-for="(item, k) in subjectList"
          :key="k"
        >
          {{ item.disciplineName }}
        </div>
      </div>
    </div>
    <div class="my-swipe">
      <div v-show="tabIdx === 0">
        <Schedule :scheduleData="scheduleData" />
        <NoData v-if="!scheduleData.length" />
      </div>
      <van-swipe ref="swipe" :show-indicators="false" @change="onChange">
        <van-swipe-item v-for="(item, k) in subjectList" :key="k">
          <div class="swiper">
            <Plan v-show="tabIdx === 1" :planData="planData" />
          </div>
        </van-swipe-item>
      </van-swipe>
       <NoData v-if="tabIdx === 1 &&!planData.length" />
    </div>
    <div class="foot" @click="openChat">
      <div>获取精细复习规划</div>
    </div>
  </div>
</template>

<script>
import { reqExamSchedule, reqExamPlan, reqExamSubject, reqExamSeason } from '@/api/examPlan';
import Plan from './components/plan.vue';
import Schedule from './components/schedule.vue';
import NoData from './components/noData.vue';

export default {
  components: {
    Plan,
    Schedule,
    NoData,
  },
  data() {
    return {
      show: false,
      yearCode: '',
      tabIdx: 0,
      tab: [
        {
          name: '考研日程',
          id: 0,
        },
        {
          name: '备考规划',
          id: 1,
        },
      ],
      examSeasonName: '',
      examSeason: [],
      subjectList: [],
      subjectCode: 0,
      mutationObserverVal: null,
      planData: [],
      scheduleData: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    changeTab(i) {
      this.tabIdx = i;
    },
    onChange(i) {
      this.subjectCode = this.subjectList[i].disciplineId;
      console.log(this.subjectCode, 9999, i);
      this.getExamPlan();
      document.getElementById(`subject-${i}`).scrollIntoView({ behavior: 'smooth' });
    },
    // 切换考季
    changeYear(code, name) {
      this.yearCode = code;
      this.subjectCode = this.subjectList[0]?.disciplineId;
      this.examSeasonName = name;
      this.show = false;
      this.getSubject();
      this.getSchedule(this.yearCode);
    },
    // 切换学科
    changeSubject(code, i) {
      this.subjectCode = code;
      this.$refs.swipe.swipeTo(i);
      this.getExamPlan();
    },
    openChat() {
      mantis?.requestChat();
    },
    // 查考季
    async getExamSeason() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { data } = await reqExamSeason();
      this.examSeason = data.filter((ele) => ele.examSeasonId !== '9') || [];
      this.yearCode = this.examSeason[0]?.examSeasonId;
      this.examSeasonName = this.examSeason[0]?.examSeasonName;
      this.getSubject();
      this.getSchedule(this.yearCode);
    },
    // 查学科
    async getSubject() {
      const { data } = await reqExamSubject(this.yearCode);
      this.subjectList = data || [];
      this.subjectCode = data?.[0]?.disciplineId;
      if(!this.subjectList.length){
        this.$toast.clear()
        return
      }
      this.getExamPlan();
    },
    // 查日程
    async getSchedule(code) {
      const { data } = await reqExamSchedule(code);
      const { nodeList } = data || {};
      this.scheduleData = nodeList;
    },
    // 查规划
    async getExamPlan() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { data } = await reqExamPlan(this.yearCode, this.subjectCode);
      if (!data) {
        this.planData = [];
      }
      const { stageList } = data || {};
      this.planData = stageList || [];
      this.$toast.clear();
    },
    loadMantisChat() {
      let srcStr =
        'https://pg-chatn9.bjmantis.net/chat/js/dist/mantis.min.js?7926#62eb7bf6a24685000153eefb';
      const script = document.createElement('script');
      script.src = srcStr;
      script.defer = true;
      script.setAttribute('type', 'text/javascript');
      document.head.appendChild(script);
    },
    tangLangInit() {
      // 记录进入详情页时浏览器历史记录的长度;
      this.windowHistoryLength = window.history.length;
      // 处理螳螂弹窗打开时插入历史记录的问题
      let target;
      const time = setInterval(() => {
        target = document.getElementById('mantisChatBox');
        if (target) {
          // eslint-disable-next-line consistent-return
          this.mutationObserverVal = new MutationObserver(() => {
            if (
              target.style.display === 'none' &&
              window.history.state.url === window.location.href
            ) {
              const num = window.history.length - this.windowHistoryLength;
              if (num > 0) {
                window.history.go(-num);
                setTimeout(() => {
                  document.title = '考研规划';
                }, 500);
                return false;
              }
            } else {
              document.title = '考研规划';
            }
          });
          this.mutationObserverVal.observe(target, { attributeFilter: ['style'], subtree: true });
          clearInterval(time);
        }
      }, 500);
    },
  },
  created() {},
  mounted() {
    this.getExamSeason();
    this.tangLangInit();
    this.loadMantisChat();
    document.title = '考研规划';
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.page.active {
  .head-box {
    height: 366px;
  }
}
.page {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 750px;
  height: 100vh; /* 使用视口高度确保父容器高度为整个视口 */
  background: #fff;
  .head-box {
    height: 275px;
  }
  .my-swipe {
    flex: 1;
    overflow: auto;
  }
  .head {
    position: relative;
    width: 100%;
    height: 275px;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examPlan/main.png')
      no-repeat;
    background-size: 100%;
    .examYear {
      display: flex;
      align-items: center;
      padding: 14px 36px;
      span {
        color: #fff;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
      }
      img {
        width: 14px;
        height: 14px;
      }
    }
    .tab {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 0 36px;
      div {
        width: 330px;
        height: 80px;
        color: #ff7f41;
        font-weight: 500;
        font-size: 29px;
        line-height: 80px;
        text-align: center;
        background: #fff;
        border-radius: 18px 18px 0 0;
      }
      div.active {
        color: #fff;
        background: #ff9666;
      }
    }
    .yearList {
      position: absolute;
      top: 65px;
      left: 36px;
      z-index: 2;
      width: 163px;
      padding: 14px 0;
      background: #fff;
      border-radius: 14px;
      box-shadow: 0 5 11px 0 rgba(0, 0, 0, 0.07);
      div {
        height: 51px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 51px;
        text-align: center;
      }
      div.active {
        color: #ff7f41;
        background: #fff3ee;
      }
    }
  }
  .major {
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    margin-left: 11px;
    overflow-x: scroll;
    white-space: nowrap;
    border-bottom: 1px solid #ececec;
    .subject {
      flex: 0 0 auto;
      box-sizing: border-box;
      height: 91px;
      margin: 0 25px;
      color: #333;
      font-weight: 500;
      font-size: 25px;
      line-height: 91px;
      text-align: center;
    }
    .subject.active {
      position: relative;
      color: #ff7f41;
    }
    .subject.active::after {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      width: 29px;
      height: 7px;
      margin: 0 auto;
      background: #ff7f41;
      border-radius: 5px;
      content: '';
    }
  }
  .swiper {
    width: 100%;
    height: 100%;
  }

  .foot {
    // position: fixed;
    // bottom: 0;
    // left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 750px;
    height: 167px;
    background: #fff;
    border-radius: 22px 22px 2px 2px;
    box-shadow: 0 -4px 14px 0 rgba(0, 0, 0, 0.05);
    div {
      width: 678px;
      height: 80px;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 49px;
    }
  }
}
</style>
